export default __webpack_public_path__ + "static/media/construction--barrier--temporary.c295cec2.png";